module.exports = __webpack_public_path__ + "static/fipcunicorn1-110c43b85440fe15a6d45fe10250b736.jpeg";